export enum EScrollPrefix {
  PLACE = 'place-id-',
  HOTEL = 'hotel-id-',
  ELEMENT = 'element-id-',
  DISTANCE = 'distance-id-',
}
